import { Grid } from '@mui/material'
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form'
import TextField from '../../../components/fields/FormTextField'
import { buttonTypesEnum } from '../../../components/button/enums/buttonTypesEnum'
import { fontFamilyMonserrat, gecinaBrownMain, WHITE } from '../../../theme'
import Button from '../../../components/button/Button'
import AutorenewIcon from '@mui/icons-material/Autorenew'
import React, { useContext } from 'react'
import { FILTRES_COMPTES_NOMENCLATURE_CHARGES } from '../enums/filtresComptesNomenclatureChargesEnum'
import { ComptesNomenclatureChargesContext } from '../context/ComptesNomenclatureChargesContext'
import { FiltresComptesNomenclatureChargesModel } from '../types/comptesNomenclatureChargesModel'
import { getListeComptesNomenclatureCharges } from '../api/comptesNomenclatureChargesAPI'
import { styled } from '@mui/system'

export const SpanVide = styled((props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>) => (<span {...props} />))(({ theme }) => (
	{
		width: '100%',
		paddingRight: 15,
		paddingTop: 7,
		fontSize: 14,
		marginLeft: 0,
		boxSizing: 'border-box',
		textAlign: 'left',
		fontFamily: fontFamilyMonserrat,
		fontWeight: 500
	}
))

const INITIAL_VALEURS_FORMULAIRE = {
	[FILTRES_COMPTES_NOMENCLATURE_CHARGES.COMPTE]: ''
}

const FiltresComptesNomenclatureCharges = () => {
	const { setChargementComptesNomenclatureCharges, setComptesNomenclatureCharges, setOuverturePopin, filtresCNC, setFiltresCNC } = useContext(ComptesNomenclatureChargesContext)
	const methods = useForm<FiltresComptesNomenclatureChargesModel>({
		defaultValues: INITIAL_VALEURS_FORMULAIRE
	})
	const { register, handleSubmit, reset } = methods

	const onSubmit: SubmitHandler<FiltresComptesNomenclatureChargesModel> = (values) => {
		setChargementComptesNomenclatureCharges(true)
		const data = {
			...filtresCNC,
			[FILTRES_COMPTES_NOMENCLATURE_CHARGES.PAGE]: 1
		}
		setFiltresCNC(data)

		// Récupération de la liste des procédures selon les valeurs du filtre
		return getListeComptesNomenclatureCharges(1, values.compte)
			.then((response) => {
				setComptesNomenclatureCharges(response)
				setChargementComptesNomenclatureCharges(false)
			})
	}

	const ajoutCompte = () => setOuverturePopin({ open: true, compteNomenclatureCharges: undefined })

	return (
		<FormProvider {...methods}>
			<form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
				<Grid container spacing={2}>
					<Grid item xs={3}>
						<TextField
							register={register(FILTRES_COMPTES_NOMENCLATURE_CHARGES.COMPTE, {
								maxLength: {
									value: 20,
									message: 'Le compte est limité à 20 caractères'
								}
							})}
							maxLength={20}
							id={FILTRES_COMPTES_NOMENCLATURE_CHARGES.COMPTE}
							label="Compte"
							placeholder="Saisir un n° de compte"
						/>
					</Grid>

					<Grid container item xs={3} spacing={2} sx={{ m: 0 }} alignContent="flex-start">
						<SpanVide> </SpanVide>

						<Grid item xs={7} sx={{ pt: '0px !important', height: 'fit-content' }}>
							<Button
								sx={{
									height: '32px',
									p: 0,
									minWidth: '100%',
									fontWeight: 600
								}}
								bgcolor={gecinaBrownMain}
								color={WHITE}
								border={false}
								disabled={false}
								type={buttonTypesEnum.submit}
							>
								Filtrer
							</Button>
						</Grid>

						<Grid item xs={3} md={2} sx={{ pt: '0px !important', height: 'fit-content' }}>
							<Button
								sx={{
									height: 32,
									p: 0,
									minWidth: '100%'
								}}
								bgcolor={gecinaBrownMain}
								color={WHITE}
								border={false}
								disabled={false}
								type={buttonTypesEnum.submit}
								onClick={() => reset(INITIAL_VALEURS_FORMULAIRE)}
							>
								<AutorenewIcon />
							</Button>
						</Grid>
					</Grid>

					<Grid container item xs={3} spacing={2} sx={{ m: 0, ml: 'auto' }} alignContent="flex-start">
						<SpanVide> </SpanVide>

						<Grid item xs={12} sx={{ pt: '0px !important', height: 'fit-content' }}>
							<Button
								sx={{
									height: '32px',
									p: 0,
									minWidth: '100%',
									fontWeight: 600
								}}
								bgcolor={gecinaBrownMain}
								color={WHITE}
								border={false}
								disabled={false}
								type={buttonTypesEnum.button}
								onClick={ajoutCompte}
							>
								Ajouter un compte
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</form>
		</FormProvider>
	)
}

export default FiltresComptesNomenclatureCharges